import React from 'react';
import { CheckIcon, LockIcon, MailIcon } from 'lucide-react';
interface EmailVerificationStepProps {
  email: string;
  verificationCode: string;
  isEmailSubmitted: boolean;
  isVerified: boolean;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onVerificationCodeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onVerifyEmail: () => void;
  onChangeEmail: () => void;
  onCompleteOnboarding: () => void;
  onPrevStep: () => void;
}
export const EmailVerificationStep = ({
  email,
  verificationCode,
  isEmailSubmitted,
  isVerified,
  onEmailChange,
  onVerificationCodeChange,
  onVerifyEmail,
  onChangeEmail,
  onCompleteOnboarding,
  onPrevStep
}: EmailVerificationStepProps) => {
  return <div data-id="element-423">
      <h1 className="text-3xl font-bold mb-4" data-id="element-424">Verify Your Email</h1>
      <p className="text-xl mb-6" data-id="element-425">
        To complete your setup, please verify your email address.
      </p>
      <div className="mb-8" data-id="element-426">
        {!isEmailSubmitted ? <div className="space-y-6" data-id="element-427">
            <div className="relative" data-id="element-428">
              <MailIcon className="absolute left-3 top-3 text-gray-400" size={24} data-id="element-429" />
              <input type="email" placeholder="Enter your email address" value={email} onChange={onEmailChange} className="w-full p-3 pl-12 border border-gray-300 rounded-lg text-lg" data-id="element-430" />
            </div>
            <button onClick={onVerifyEmail} disabled={!email.includes('@')} className={`w-full p-3 rounded-lg font-medium ${email.includes('@') ? 'bg-gradient-to-r from-sky-500 to-blue-600 text-white hover:from-sky-600 hover:to-blue-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed'} transition-colors`} data-id="element-431">
              Verify
            </button>
            <p className="text-sm text-gray-500 text-center" data-id="element-432">
              We'll send a 6-digit verification code to your email.
            </p>
          </div> : <div className="space-y-6" data-id="element-433">
            <div data-id="element-434">
              <p className="text-green-600 mb-4" data-id="element-435">
                We've sent a verification code to <strong data-id="element-436">{email}</strong>
              </p>
              <div className="relative" data-id="element-437">
                <LockIcon className="absolute left-3 top-3 text-gray-400" size={24} data-id="element-438" />
                <input type="text" placeholder="Enter 6-digit code" value={verificationCode} onChange={onVerificationCodeChange} maxLength={6} className="w-full p-3 pl-12 border border-gray-300 rounded-lg text-lg tracking-widest text-center font-mono" data-id="element-439" />
              </div>
              <div className="mt-2 flex justify-between" data-id="element-440">
                <button className="text-sky-600 text-sm hover:underline" onClick={onChangeEmail} data-id="element-441">
                  Change email
                </button>
                <button className="text-sky-600 text-sm hover:underline" onClick={onVerifyEmail} data-id="element-442">
                  Resend code
                </button>
              </div>
            </div>
            {isVerified && <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center" data-id="element-443">
                <CheckIcon className="inline-block text-green-500 mb-2" size={24} data-id="element-444" />
                <p className="text-green-700" data-id="element-445">Email verified successfully!</p>
              </div>}
            <button onClick={onCompleteOnboarding} disabled={!isVerified} className={`w-full p-3 rounded-lg font-medium ${isVerified ? 'bg-gradient-to-r from-sky-500 to-blue-600 text-white hover:from-sky-600 hover:to-blue-700' : 'bg-gray-200 text-gray-500 cursor-not-allowed'} transition-colors`} data-id="element-446">
              Complete Setup
            </button>
          </div>}
      </div>
      <div className="flex justify-between mt-8" data-id="element-447">
        <button onClick={onPrevStep} className="border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-medium hover:bg-gray-50 transition-colors" data-id="element-448">
          Back
        </button>
      </div>
    </div>;
};